import { useNonReligiousMode } from '@fs/zion-permissions'
import { colors, LayoutBand, usePageWidth } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useShowTempleContext } from '../../providers/ShowTempleContext'
import { type TabItem, TabsSkeleton } from './tabsSkeletonShared'

export default function PersonPageTabsSkeleton(): JSX.Element {
  const [t] = useTranslation()
  const isMobile = usePageWidth()({ lg: false, default: true })
  const [nonReligiousModeCheck, status, error] = useNonReligiousMode()
  const nonReligiousMode = status === 'loading' || error !== null || nonReligiousModeCheck
  const [showTemple, templeStatus] = useShowTempleContext()
  const showOrdinances = showTemple && templeStatus === 'loaded' && !nonReligiousMode

  const desktopTabs: TabItem[] = [
    { key: 'about', content: t('tree-person.about.label') },
    { key: 'details', content: t('tree-person.details.label') },
    { key: 'sources', content: `${t('tree-person.sources.label')} (0)` },
    { key: 'collaborate', content: t('tree-person.collaborate-count.label', { count: 0 }) },
    { key: 'memories', content: `${t('tree-person.memories.label')} (0)` },
    { key: 'timeline', content: t('tree-person.timeline.header') },
    ...(showOrdinances ? [{ key: 'ordinances', content: t('tree-person.ordinances.label') }] : []),
  ]

  const mobileTabs: TabItem[] = [
    { key: 'about', content: t('tree-person.about.label') },
    { key: 'vitals', content: t('tree-person.vitals.label') },
    { key: 'other', content: t('tree-person.other.label') },
    { key: 'family', content: t('tree-person.family.header') },
    { key: 'sources', content: `${t('tree-person.sources.label')} (0)` },
    { key: 'collaborate', content: t('tree-person.collaborate-count.label', { count: 0 }) },
    { key: 'memories', content: `${t('tree-person.memories.label')} (0)` },
    { key: 'timeline', content: t('tree-person.timeline.header') },
    ...(showOrdinances ? [{ key: 'ordinances', content: t('tree-person.ordinances.label') }] : []),
  ]

  return (
    <LayoutBand maxWidth="lg" color={colors.gray00}>
      <TabsSkeleton tabs={isMobile ? mobileTabs : desktopTabs} centered={!isMobile} />
    </LayoutBand>
  )
}
